import React, { useContext } from 'react';
import Pride from '../components/events/Pride.js';
import { Link } from 'react-router-dom';
import { LanguageContext } from '../context/LanguageContext.js';

function Home() {
  const { language, translations } = useContext(LanguageContext);

  return (
    <div className="page home">
      <img className="pufok-home-icon" src="https://pufok.gay/PublicResources/logo512x.png" alt="pufok" />
      <h1 className="header">{translations[language].pages.home.h1}</h1>
      <p className="paragraph">{translations[language].pages.home.p1}</p>
      <p className="paragraph">
        {translations[language].pages.home.p2.p21}{' '}
        <Link to="/about">{translations[language].pages.home.p2.p22}</Link>
        {translations[language].pages.home.p2.p23}{' '}
        <Link to="/contact">{translations[language].pages.home.p2.p24}!</Link>
      </p>
      <p className="paragraph">
        {translations[language].pages.home.p3}{' '}
        <a
          href="https://git.gay/DeltaStudio/PufokReactApp/"
          title="git.gay"
          target="_blank"
          rel="noreferrer"
        >
          git.gay
        </a>
      </p>
      <p className="paragraph">
        {translations[language].pages.home.p4}: 01.07.2025 6:10 UTC +3
      </p>
      <br />
      <Pride />
    </div>
  );
}

export default Home;
